<template>
  <div class="pb-[16px] px-5 md:px-6 lg:px-8 pt-[75px] overflow-x-hidden">
    <div v-for="monthIdx in 2" :key="monthIdx">
      <!-- Month header -->
      <div
        class="text-[1.25rem] md:text-[1.5rem] lg:text-[1.75rem] font-black mt-[20px] mb-[12px] tracking-[-0.03em]"
        :class="{ 'pt-[60px]': monthIdx === 1 }"
      >
        <SkeletonBase width="150px" height="28px" />
      </div>
      <!-- Event cards -->
      <div v-for="eventIdx in 3" :key="eventIdx" class="mb-[12px]">
        <div
          class="border border-1 rounded-xl p-4 relative overflow-hidden"
          style="background-color: #f6f4f0; border-color: #3c3a36"
        >
          <!-- Event title -->
          <div class="mb-2">
            <SkeletonBase width="70%" height="20px" />
          </div>
          <!-- Event date/time -->
          <div class="flex flex-col gap-2 mb-3">
            <SkeletonBase width="40%" height="16px" />
            <SkeletonBase width="50%" height="16px" />
          </div>
          <!-- Event tags -->
          <div class="flex flex-row gap-2">
            <SkeletonBase width="60px" height="24px" borderRadius="12px" />
            <SkeletonBase width="60px" height="24px" borderRadius="12px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBase from '@/components/common/SkeletonBase.vue';

export default {
  name: 'SkeletonCalendarList',
  components: { SkeletonBase },
};
</script>
